import React from "react";
import './index.css';
// import GeoPattern from "geopattern";

import './user-page.css';
import API from "../utils/api";
import {arr2obj, html2plaintext, serrializer} from "../utils/utils";
import {TitleComponent} from "../utils/title";
import Spinner from "../utils/spinner";
import CoursesFeed from "../course-snippets/feed/v3";
import BlogFeed from "../course-snippets/blog";
// import PublicContacts from "./public-contacts";

class PublicProfile extends React.Component {
    constructor (props) {
        super();

        this.state = {
            userId: null,
            loading: false,
            courses: [],
            loadedLength: 0,
            no_courses: false,
            user: null,
        };
    }

    loadCourses = () => {
        const t = this;
        const p = this.props;
        const ud = p.userData;
        const ids = ud.courses;

        if (ids) {
            this.setState({loading: true});

            API.get('/whub/v3/course?' + serrializer({include: ids, per_page: 100}))
                .then(function (r) {
                    const totalFound = r.data.total;
                    const data = r.data.results;

                    t.setState({loading: false, courses: data, loadedLength: totalFound});
                })
                .catch(function (error) {
                    t.setState({loading: false});
                    console.log(error);
                });
        }

    };

    renderSubscribeButton = () => {
      const { user } = this.props;
      const school = this.props.userData;

      if (!user || !user.subscriptions || school.role !== "school") {
        return ''
      }

      if (user.subscriptions.schools.includes(school.id)) {
        return <div className="profile_button unsubcribe" onClick={this.unsubscribe}>
          <span>Отписаться</span>
        </div>
      } else {
        return <div className="profile_button subcribe" onClick={this.subscribe}>
          <span>Подписаться</span>
        </div>
      }
    }

    subscribe = () => {
      const t = this;
      const { user } = t.state;
      const school = this.props.userData;

      const body = {
        entity: "school"
      }

      if (user) {
        t.setState({loading: true});
        API.put('/whub/v3/subscribe/' + school.id, body)
          .then((result) => {
            console.log(result);
          })
          .catch((error) => {
            console.log(error);
          })
          .finally(() =>{
            t.props.reloadUserData((user) => {
              this.setState({user});
              t.setState({loading: false});
            });
          })
      }
    }

    unsubscribe = () => {
      const t = this;
      const { user } = t.state;
      const school = this.props.userData;

      const body = {
        data: {
          entity: "school"
        }
      }

      if (user) {
        t.setState({loading: true});
        API.delete('/whub/v3/subscribe/' + school.id, body)
          .then((result) => {
            console.log(result);
          })
          .catch((error) => {
            console.log(error);
          })
          .finally(() =>{
            t.props.reloadUserData((user) => {
              this.setState({user});
              t.setState({loading: false});
            });
          })
      }
    }

    componentDidMount() {
        document.body.classList.add('no_dashboard');

        const p = this.props;
        const ud = p.userData;
        this.setState({userId: ud.id, user: p.user});
        this.loadCourses();
    };

    componentWillUnmount() {
        document.body.classList.remove('no_dashboard');
    };

    componentDidUpdate() {
        const s = this.state;
        const p = this.props;
        const ud = p.userData;

        if (ud.id !== s.userId && !s.loading) {
            this.setState({courses: [], userId: ud.id});
            this.loadCourses();

        }
    };

    getSchoolType = (type) => {
        const schoolTypesList = [
            {value: 'online-school', label: 'онлайн-школа'},
            {value: 'school', label: 'школа'},
            {value: 'university', label: 'университет'},
            {value: 'institute', label: 'институт'},
            {value: 'academy', label: 'академия'},
            {value: 'college', label: 'колледж'},
            {value: 'author', label: 'автор'},
            {value: 'expert', label: 'эксперт'},
            {value: 'blogger', label: 'блогер'},
            {value: 'instructor', label: 'преподаватель'},
            {value: 'teacher', label: 'учитель'},
            {value: 'lecturer', label: 'лектор'},
            {value: 'trainer', label: 'тренер'}
        ];
        const obj = arr2obj(schoolTypesList, 'value');

        return obj[type].label;
    };

    render() {
        const t = this;
        const p = t.props;
        const ud = p.userData;
        const isSchool = ud.role === 'school';

        const {courses, loading} = t.state;

        const patternaName = ud.display_name ? ud.display_name : ud.name;
        // const coverPattern = GeoPattern.generate(patternaName, {color: '#434A5C'});

        const avatar = ud.avatar ? <img className="avatar" src={ud.avatar} alt="" /> : <span>{patternaName[0]}</span>;

        const roleMap = {
            school: 'школа',
            student: 'студент'
        };

        const role = isSchool && ud.school_type ? t.getSchoolType(ud.school_type) : roleMap[ud.role];

        const roleMapRod = {
            school: 'школы',
            student: 'студента'
        };

        const about = isSchool && ud.about && ud.about.length ? <div className="profile_about">{ud.about}</div> : '';
        // const contacts = isSchool && ud.contacts ? <PublicContacts {...p} />: '';

        const page_title = <TitleComponent title={patternaName + ' - профиль ' + roleMapRod[ud.role]} />;


        const coursesFeed = isSchool && courses.length ? <div className="profile_courses_feed">
            <h2>Курсы</h2>
            <CoursesFeed {...p} courses={courses} />
        </div> : '';

        const articlesFeed = isSchool && ud.articles && ud.articles.length ?  <BlogFeed
            {...p}
            articles={ud.articles}
            title={'Статьи'} /> : '';

        return (
            <div className="public_profile">
                <div className="profile_bg"> </div>
                <div className="profile_userpic">{avatar}</div>
                <div className="profile_name">{html2plaintext(patternaName)}</div>
                <div className="profile_role">{role}</div>
                {this.renderSubscribeButton()}

                <div className="profile_about_wrapper">
                    {about}
                    {/*{contacts}*/}
                </div>

                <div className="profile_courses_list">

                    {coursesFeed}
                    {articlesFeed}

                </div>
                {page_title}
                <Spinner show={loading} />
            </div>
        )
    }
}

export default PublicProfile;